module.exports = __webpack_public_path__ + "static/olivier_keutgens_resume-93b3a7375739a60bf17801578a25f779.pdf";